import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/authentication/Login';

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation) {
    // Resolve the landing page from billing after signing in on a protected route.
    if (pathname !== '/') {
      return <Navigate to="/" replace />;
    }
    setRequestedLocation(null);
  }

  return <>{children}</>;
}
